/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderApprovalPermissionType } from './OrderApprovalPermissionType';
import {
    OrderApprovalPermissionTypeFromJSON,
    OrderApprovalPermissionTypeFromJSONTyped,
    OrderApprovalPermissionTypeToJSON,
} from './OrderApprovalPermissionType';

/**
 * Details of an order approval permission result related to an order
 * @export
 * @interface OrderApprovalPermissionResult
 */
export interface OrderApprovalPermissionResult {
    /**
     * Name of the approver responsible for this permission result.
     * @type {string}
     * @memberof OrderApprovalPermissionResult
     */
    approverName?: string;
    /**
     * Any comments the approver added to the approval item.
     * @type {string}
     * @memberof OrderApprovalPermissionResult
     */
    approverNotes?: string;
    /**
     * 
     * @type {OrderApprovalPermissionType}
     * @memberof OrderApprovalPermissionResult
     */
    permissionType?: OrderApprovalPermissionType;
    /**
     * Status of the order approval.
     * @type {string}
     * @memberof OrderApprovalPermissionResult
     */
    statusDisplay?: string;
}

/**
 * Check if a given object implements the OrderApprovalPermissionResult interface.
 */
export function instanceOfOrderApprovalPermissionResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderApprovalPermissionResultFromJSON(json: any): OrderApprovalPermissionResult {
    return OrderApprovalPermissionResultFromJSONTyped(json, false);
}

export function OrderApprovalPermissionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderApprovalPermissionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'approverName': !exists(json, 'approverName') ? undefined : json['approverName'],
        'approverNotes': !exists(json, 'approverNotes') ? undefined : json['approverNotes'],
        'permissionType': !exists(json, 'permissionType') ? undefined : OrderApprovalPermissionTypeFromJSON(json['permissionType']),
        'statusDisplay': !exists(json, 'statusDisplay') ? undefined : json['statusDisplay'],
    };
}

export function OrderApprovalPermissionResultToJSON(value?: OrderApprovalPermissionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'approverName': value.approverName,
        'approverNotes': value.approverNotes,
        'permissionType': OrderApprovalPermissionTypeToJSON(value.permissionType),
        'statusDisplay': value.statusDisplay,
    };
}

